"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WizardInputOptionsType;

(function (WizardInputOptionsType) {
  WizardInputOptionsType["entityType"] = "entityType";
  WizardInputOptionsType["commentaryType"] = "commentaryType";
  WizardInputOptionsType["disclaimerType"] = "disclaimerType";
  WizardInputOptionsType["property"] = "property";
  WizardInputOptionsType["statisticCode"] = "statisticCode";
  WizardInputOptionsType["allocationCode"] = "allocationCode";
  WizardInputOptionsType["timeseriesCode"] = "timeseriesCode";
  WizardInputOptionsType["statisticProperty"] = "statisticProperty";
  WizardInputOptionsType["allocationProperty"] = "allocationProperty";
  WizardInputOptionsType["timeseriesProperty"] = "timeseriesProperty";
})(WizardInputOptionsType = exports.WizardInputOptionsType || (exports.WizardInputOptionsType = {}));